<tinymce [(ngModel)]="htmlContent" (ready)="ready($event)"></tinymce>